import React from 'react'
import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import styles from 'components/FileUploader/file-uploader.module.scss'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import StatusIcon from 'components/FileUploader/subcomponents/StatusIcon'
import { useTranslation } from 'react-i18next'

const FileRow = ({ name, progress, remove, error, disabled }) => {
  const { t } = useTranslation()
  return (
    <Grid gap={16} wrap={false}>
      <StatusIcon status={error ? 'error' : 'loaded'} />

      <Grid
        direction={'column'}
        gap={4}
        className={clsx(
          styles['row__description'],
          styles['col'],
          styles['col-2'],
          {
            [styles['row__description_error']]: error,
          },
        )}
      >
        <Typography
          variant={'p8'}
          noMargin
          className={styles['row__file-name']}
        >
          {name}
        </Typography>

        {error ? (
          <Typography variant={'p10'} className={styles['error']} noMargin>
            {t(`common::uploader.errors.${error}`)}
          </Typography>
        ) : (
          <div className={styles['progressbar']}>
            <div
              className={styles['progressbar__inner']}
              style={{ width: progress + '%' }}
            />
          </div>
        )}
      </Grid>

      <Button
        startIcon={<Icon name={'close'} />}
        noLabel
        color={'Interface-Seventh'}
        size={'m'}
        onClick={remove}
        disabled={disabled}
      />
    </Grid>
  )
}

FileRow.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  progress: PropTypes.number,
  remove: PropTypes.func,
}

export default FileRow
